/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1HIcon20Regular = forwardRef('ArrowDim1HIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.28 4.97a.75.75 0 0 1 0 1.06L3.061 9.25h13.878l-3.22-3.22a.75.75 0 0 1 1.061-1.06l3.616 3.616a2 2 0 0 1 0 2.828L14.78 15.03a.75.75 0 1 1-1.06-1.06l3.22-3.22H3.06l3.22 3.22a.75.75 0 1 1-1.06 1.06l-3.617-3.616a2 2 0 0 1 0-2.828L5.22 4.97a.75.75 0 0 1 1.061 0Z" })));
});
